import { Box, Collapse, Group, Paper, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown } from "@tabler/icons-react";
import { FONT, TW } from "./theme";

const CollapsibleTeamSection = ({
  title,
  titleColor,
  accentColor,
  defaultOpened = true,
  children,
}: {
  title: string;
  titleColor: string;
  accentColor: string;
  defaultOpened?: boolean;
  children: React.ReactNode;
}) => {
  const [opened, { toggle }] = useDisclosure(defaultOpened);

  return (
    <Paper
      withBorder
      radius="md"
      style={{
        background: TW.white,
        borderColor: TW.gray200,
        borderLeft: `3px solid ${accentColor}`,
        overflow: "hidden",
      }}
    >
      <Group
        justify="space-between"
        onClick={toggle}
        px="md"
        py="xs"
        style={{
          cursor: "pointer",
          background: `${accentColor}0D`,
          borderBottom: opened ? `1px solid ${TW.gray200}` : "none",
        }}
      >
        <Text size={`${FONT.sm}px`} fw={700} c={titleColor}>
          {title}
        </Text>
        <IconChevronDown
          size={16}
          color={titleColor}
          style={{
            transition: "transform 150ms",
            transform: opened ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Group>
      <Collapse in={opened}>
        <Box px="md" py="sm">
          {children}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default CollapsibleTeamSection;
